import React from "react";

import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

import LogoImage from "../../assets/images/addyou_white.png";
import css from "./legalPage.module.scss";

export interface LegalPageProps {
  title: string;
  lastUpdated?: string;
  sections: {
    heading: string;
    body: string[];
    bullets?: string[];
    table?: {
      headers: string[];
      rows: string[][];
    };
  }[];
  backLabel?: string;
  backPath?: string;
}

const LegalPage: React.FC<LegalPageProps> = ({
  title,
  lastUpdated,
  sections,
  backLabel = "Back",
  backPath = "/login",
}) => {
  const navigate = useNavigate();

  return (
    <main className={css.page}>
      <header className={css.topbar}>
        <div className={css.brand}>
          <img className={css.brandLogo} src={LogoImage} alt="AddYou" />
        </div>
        <Button
          className={css.backButton}
          variant="text"
          startIcon={<ArrowBack />}
          onClick={() => navigate(backPath)}
        >
          {backLabel}
        </Button>
      </header>

      <div className={css.content}>
        <h1 className={css.title}>{title}</h1>
        {lastUpdated && (
          <div className={css.meta}>Last updated: {lastUpdated}</div>
        )}

        <div className={css.document}>
          {sections.map((section) => (
            <section className={css.section} key={section.heading}>
              <h2 className={css.heading}>{section.heading}</h2>
              {section.body.map((paragraph) => (
                <p className={css.paragraph} key={paragraph}>
                  {paragraph}
                </p>
              ))}
              {section.heading.toLowerCase() === "contact us" && (
                <div className={css.contactBlock}>
                  <div className={css.contactName}>Jenny Åkesson</div>
                  <div>Tavastgatan 5, 118 24</div>
                  <div>Stockholm, Sweden</div>
                  <a className={css.contactLink} href="mailto:admin@addyou.se">
                    admin@addyou.se
                  </a>
                </div>
              )}
              {section.bullets && (
                <ul className={css.bullets}>
                  {section.bullets.map((bullet) => (
                    <li key={bullet} className={css.bulletItem}>
                      {bullet}
                    </li>
                  ))}
                </ul>
              )}
              {section.table && (
                <div className={css.tableWrap}>
                  <table className={css.table}>
                    <thead>
                      <tr>
                        {section.table.headers.map((header) => (
                          <th key={header}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {section.table.rows.map((row, rowIndex) => (
                        <tr key={`${section.heading}-${rowIndex}`}>
                          {row.map((cell, cellIndex) => (
                            <td
                              key={`${section.heading}-${rowIndex}-${cellIndex}`}
                            >
                              {cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
